"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.detailNotFoundAmp = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var Detail_1 = require("@/pages/detail/components/Detail");
var react_amphtml_1 = require("react-amphtml");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var format_1 = require("@/utils/format");
var propertyToUrl_1 = require("@/transformers/propertyToUrl");
var DetailNotFound_1 = require("@/pages/detail/components/DetailNotFound");
exports.detailNotFoundAmp = function (props) {
    var renderSimilarItemWithType = function (it, i, type, currencyCode) {
        var renderPrice = function (item, prefix) {
            var price = type === SfilterTypeGroup_1.SfilterType.BUY ? item.salePrice : item.leasePrice;
            if (price <= 0 || item.isSubjectToOffer) {
                return props.t.subjectToOffer;
            }
            return format_1.default.currency(price, prefix + " ");
        };
        var renderSize = function (item) {
            var netsize = item.sizeSaleable;
            var grosssize = item.sizeGross;
            var size = netsize || grosssize;
            return format_1.default.comma(size);
        };
        var bedFields = it.amenities.filter(function (it2) { return it2.key === 'bed'; });
        var bathFields = it.amenities.filter(function (it2) { return it2.key === 'bath'; });
        var beds = bedFields.length ? bedFields[0].value : -1;
        var baths = bathFields.length ? bathFields[0].value : -1;
        var href = propertyToUrl_1.propertyToUrl(props.langCode, it.building, it.referenceId, it.type);
        return (React.createElement("div", { className: "s-it", key: i },
            React.createElement("a", { href: href, className: "s-image" },
                React.createElement(react_amphtml_1.AmpImg, { specName: "default", width: "175", height: "131", layout: "responsive", src: it.images.length ? it.images[0].path : "" })),
            React.createElement("div", { className: "s-body" },
                React.createElement("a", { href: href, className: "s-name" }, it.building),
                React.createElement("div", { className: "s-price" }, renderPrice(it, currencyCode)),
                React.createElement("div", { className: "s-cs" },
                    React.createElement("div", { className: "s-c" },
                        React.createElement("span", { className: "s-c-value" }, renderSize(it)),
                        React.createElement("span", { className: "s-c-label" },
                            props.t.sqft,
                            "(",
                            it.sizeSaleable ? props.t.sa : props.t.gfa,
                            ")")),
                    React.createElement("div", { className: "s-c" },
                        React.createElement("span", { className: "s-c-value" }, beds),
                        React.createElement("span", { className: "s-c-label" }, props.t.beds)),
                    React.createElement("div", { className: "s-c" },
                        React.createElement("span", { className: "s-c-value" }, baths),
                        React.createElement("span", { className: "s-c-label" }, props.t.baths))))));
    };
    var gtmAttrs = {
        'data-credentials': 'include',
    };
    var gtm = "https://www.googletagmanager.com/amp.json?id=" + props.gtmId + "&gtm.url=SOURCE_URL";
    var renderSimilarItem = function (it, i) {
        return renderSimilarItemWithType(it, i, props.similar.filterType, props.similar.currencyCode);
    };
    var sameBuildingProperties = props.sameBuilding.results.slice(0, 10);
    var similarProperties = props.similar.results.slice(0, 10);
    var renderSoldMessage = function (props) { return (React.createElement("div", { className: "if-wrap" },
        React.createElement("div", { className: "if-na" },
            React.createElement("div", { className: "if-na-t" }, props.unavailableInfo.title),
            React.createElement("div", { className: "if-na-cap" },
                React.createElement("a", { className: "if-na-cap-link", href: props.unavailableInfo.link }, props.unavailableInfo.caption))))); };
    return (React.createElement(React.Fragment, null,
        props.gtmId ? React.createElement(react_amphtml_1.AmpAnalytics, __assign({}, gtmAttrs, { config: gtm })) : null,
        React.createElement("div", { className: "ct" },
            React.createElement("div", { className: "nav-bar" },
                React.createElement(react_amphtml_1.Button, { on: "tap:menu", className: "nav-menu", specName: "default", id: "menubutton" },
                    React.createElement("span", { className: "fal fa-bars" }))),
            React.createElement("div", { className: "if-pad" }, props.tResult.noPhoto),
            React.createElement("div", { className: "if-wrap" },
                React.createElement("div", { className: "if-main" },
                    React.createElement("h1", { className: "if-name" }, props.property.building),
                    props.property.address ? (React.createElement("div", { className: "if-address" },
                        React.createElement("span", { className: "fal fa-map" }),
                        " ",
                        props.property.address)) : null),
                React.createElement("div", { className: "if-side" })),
            props.property.address ? (React.createElement("div", { className: "if-c" },
                React.createElement("div", { className: "if-c-it" },
                    React.createElement("div", { className: "if-c-value" }, Detail_1.renderSize(props)),
                    React.createElement("div", { className: "if-c-label" },
                        props.t.sqft,
                        " (",
                        Detail_1.renderSizeSaGfa(props),
                        ")")),
                React.createElement("div", { className: "if-c-it" },
                    React.createElement("div", { className: "if-c-value" }, Detail_1.renderBeds(props)),
                    React.createElement("div", { className: "if-c-label" }, props.t.beds)),
                React.createElement("div", { className: "if-c-it" },
                    React.createElement("div", { className: "if-c-value" }, Detail_1.renderBaths(props)),
                    React.createElement("div", { className: "if-c-label" }, props.t.baths)))) : null,
            props.showPropertyInfo ? renderSoldMessage(props) : null,
            sameBuildingProperties.length ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "s-head" }, props.t.sameBuildingProperties),
                React.createElement(react_amphtml_1.AmpCarousel, { specName: "AMP-CAROUSEL [type=carousel]", className: "s-its", height: "220", layout: "fixed-height", type: "carousel" }, sameBuildingProperties.map(renderSimilarItem)))) : null,
            similarProperties.length ? (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "s-head" }, props.t.similarProperties),
                React.createElement(react_amphtml_1.AmpCarousel, { specName: "AMP-CAROUSEL [type=carousel]", className: "s-its", height: "220", layout: "fixed-height", type: "carousel" }, similarProperties.map(renderSimilarItem)))) : null,
            React.createElement("div", { className: "ft" }, props.dfoot.nameFootCopyright))));
};
exports.default = react_redux_1.connect(DetailNotFound_1.detailNotFoundMapStateToProps, Detail_1.DetailMapDispatchToProps)(exports.detailNotFoundAmp);
